function signup() {
	const elId = '#app-signup';
	const elClass = '.js-vue-signup';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const app = new Vue({
		el: elId,
		data: {
			signup: {
				firstname: null,
				lastname: null,
				email: null,
				company: null,
				function: null,
				password: null
			},
			error: null
		},
		created: function() {
			const self = this;
		},
		mounted: function() {
			$(elClass).removeClass('is-mounting');
		},
		methods: {
			doSignup: function() {
				window.validateAll();
				if (isLoading() || !window.isInputValid()) {
					return;
				}
				toggleLoader(true);
				const self = this;

				const trySignupWithUser = self.signup;
				POST('/auth/signup', trySignupWithUser)
					.then(xhr => {
						self.error = null;
						toggleLoader(false);
						if (xhr.status) {
							document.location.href = xhr.url;
						} else {
							toggleLoader(false);
							self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						}
					})
					.catch(xhr => {
						self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						toggleLoader(false);
					});
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
signup();
